import { BrowserModule, HammerModule, HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Injectable, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ClickOutsideDirective } from './modules/shared/directives/click-outside.directive';
import { FilterPipe } from './modules/shared/pipes/filter.pipe';
import { CoreModule } from './modules/core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { TrimRequestBodyInterceptor } from './interceptors/trim-request-body.interceptor';
import { McubeToLitrePipe } from './modules/shared/pipes/mcube-to-litre.pipe';
import { environment } from 'src/environments/environment';
import { IMqttServiceOptions, MqttModule } from 'ngx-mqtt';
import { ToastrModule } from 'ngx-toastr';
import * as Hammer from 'hammerjs';
import { UserLoginLoaderComponent } from "./modules/feature/login/components/user-login-loader/user-login-loader.component";

@Injectable()
export class HammerConfig extends HammerGestureConfig {
  override overrides = <any>{
    // override hammerjs default configuration
    //'swipe': { direction: Hammer.DIRECTION_HORIZONTAL, touchAction: "auto" }
    swipe: { direction: Hammer.DIRECTION_ALL },
  };
}

export const MQTT_SERVICE_OPTIONS: IMqttServiceOptions = {
  // Use secure WebSocket (wss) in production, otherwise use ws
  protocol: (environment.protocol === "wss") ? "wss" : "ws",

  // MQTT broker host name or IP address
  hostname: environment.broker,

  // MQTT broker port (e.g. 443)
  port: environment.port,

  // WebSocket endpoint path exposed by the broker
  // Example: wss://{hostname}/mqtt
  path: environment.path,

  // Prevent automatic connection on service creation.
  // Connection will be established manually using this._mqttService.connect(...)
  connectOnCreate: false,

  // MQTT keep-alive interval in seconds.
  // If no data is exchanged within this period, the client sends a PINGREQ
  // and expects a PINGRESP from the broker to keep the connection alive.
  keepalive: 30,

  // Maximum time to wait for a successful connection before considering it failed
  connectTimeout: 60000,

  // Time in milliseconds between automatic reconnect attempts
  // when the connection is lost
  reconnectPeriod: 0,

  

  // Automatically re-subscribe to previously subscribed topics
  // after a successful reconnection
  resubscribe: true,

};

@NgModule({
  declarations: [
    AppComponent,
    ClickOutsideDirective
  ],
  imports: [
    BrowserModule,
    // CommonModule,
    // FormsModule,
    BrowserAnimationsModule,
    HammerModule,

    // ReactiveFormsModule,
    // HttpClientModule,
    MqttModule.forRoot(MQTT_SERVICE_OPTIONS),
    ToastrModule.forRoot({
        toastClass: 'toast ngx-toastr',
        positionClass: 'toast-top-right',
        closeButton: true,
        progressBar: true,
    }),
    AppRoutingModule,
    CoreModule,
    UserLoginLoaderComponent
],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TrimRequestBodyInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerConfig
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
